import { LanguageService } from 'services/language-service';

export const DAY_IN_MILLISECONDS = 86400000;

export type DateRangePickerValue = [Date | null, Date | null];

export const monthAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

export const getDefaultMonthRange = () => {
  const startDate = monthAgo();
  const endDate = new Date();
  endDate.setHours(0);
  endDate.setMinutes(0);
  endDate.setSeconds(0);
  endDate.setMilliseconds(DAY_IN_MILLISECONDS - 1);
  return [startDate, endDate] as DateRangePickerValue;
};
export const DEFAULT_DATE_RANGE = getDefaultMonthRange();

export const getReadableFormatDateTime = (timestamp: number, includeTime = true): string => {
  const locale = LanguageService.getCurrentLanguageLocale();
  return new Date(timestamp).toLocaleString(locale.code, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...(includeTime && {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  });
};

export const formatSecondsToMinutesAndSeconds = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
